var _circle, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgBlipCirclesinline = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "transparent",
  viewBox: "0 0 40 40"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 20,
  cy: 20,
  r: 19.625,
  fill: "none",
  stroke: "#0080AB",
  strokeDasharray: "1.5 1.5",
  strokeWidth: 0.75,
  "data-figma-bg-blur-radius": 4
})), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
  cx: 20,
  cy: 20,
  r: 9.625,
  fill: "none",
  stroke: "#0080AB",
  strokeDasharray: "1.5 1.5",
  strokeWidth: 0.75
})));
export default SvgBlipCirclesinline;